import type { PermissionAuditLog } from '../types/permissionsList.types';

interface PermissionAuditBlockProps {
  logs: PermissionAuditLog[];
  isLoading: boolean;
  rollbackId: string | null;
  onRollback: (log: PermissionAuditLog) => void;
}

export function PermissionAuditBlock({ logs, isLoading, rollbackId, onRollback }: PermissionAuditBlockProps) {
  return (
    <section className="min-w-0 overflow-hidden rounded-md border border-slate-100 bg-white p-3 shadow-sm">
      <div className="min-w-0 space-y-2 text-sm">
        <div className="min-w-0">
          <h2 className="truncate font-medium text-slate-900">Nhật ký thay đổi quyền</h2>
          <p className="line-clamp-2 text-slate-500">Theo dõi và khôi phục các thay đổi quyền gần đây.</p>
        </div>
        <div className="max-h-72 overflow-auto">
          {isLoading ? (
            Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="mb-2 h-12 animate-pulse rounded-md bg-slate-50" />
            ))
          ) : logs.length ? (
            <div className="space-y-2">
              {logs.map((log) => (
                <div key={log.id} className="min-w-0 rounded-md border border-slate-100 p-3">
                  <div className="space-y-2 text-sm">
                    <div className="flex min-w-0 items-start justify-between gap-3">
                      <div className="min-w-0 space-y-1">
                        <p className="line-clamp-2 font-semibold text-slate-900">{log.summary}</p>
                        <p className="truncate text-slate-500">Người thực hiện: {log.actorName}</p>
                      </div>
                      <span className="shrink-0 rounded-md bg-slate-100 px-2 py-1 text-sm font-semibold text-slate-600">
                        {formatDateTime(log.createdAt)}
                      </span>
                    </div>
                    {log.canRollback && (
                      <button
                        type="button"
                        disabled={rollbackId === log.id}
                        onClick={() => onRollback(log)}
                        className="h-9 w-full rounded-md border border-amber-100 bg-amber-50 px-3 text-sm font-semibold text-amber-700 disabled:opacity-50"
                      >
                        {rollbackId === log.id ? 'Đang khôi phục' : 'Khôi phục thay đổi này'}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="rounded-md bg-slate-50 p-3 text-sm text-slate-500">Chưa có nhật ký thay đổi quyền.</p>
          )}
        </div>
      </div>
    </section>
  );
}

function formatDateTime(value: string | null) {
  if (!value) return '--/--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--/--';
  return date.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit' });
}
